import { MijnRoute } from '../../mijn-navigatie.model';

export const PLANNED_PAYMENT: MijnRoute = {
    path: 'ingeplande-overboeking',
    navigationEvent: 'toIngeplandeOverboeking',
    regex: /^\/ingeplande-overboeking$/,
    webcomponent: 'mijn-transacties-ingepland-webcomponent'
};
